/**
 * Company Type Distribution Chart Component
 * Pie chart showing Macro vs Micro companies
 */
import React from 'react';
import { Card } from 'antd';
import { Pie } from '@ant-design/plots';
import { LicenseTypeDistribution } from '../../services/superAdminService';
import './CompanyTypeDistribution.css';

interface CompanyTypeDistributionProps {
  data?: LicenseTypeDistribution[];
  loading?: boolean;
}

const CompanyTypeDistribution: React.FC<CompanyTypeDistributionProps> = ({ data, loading = false }) => {
  if (loading || !data || data.length === 0) {
    return (
      <Card className="company-type-distribution-card" loading={true}>
        <div className="chart-title">Company Type Distribution</div>
      </Card>
    );
  }

  const chartData = data.map(d => ({
    type: d.license_type,
    value: d.count
  }));

  const total = chartData.reduce((sum, d) => sum + d.value, 0);

  const config = {
    data: chartData,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: false, // Disable default labels to avoid the error
    legend: {
      position: 'bottom' as const,
      itemName: {
        formatter: (text: string) => {
          const item = chartData.find(d => d.type === text);
          if (!item) return text;
          const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : '0';
          return `${text}: ${percentage}%`;
        },
      },
    },
    color: ['#9c27b0', '#2196f3'],
    tooltip: {
      formatter: (datum: any) => {
        const percentage = total > 0 ? ((datum.value / total) * 100).toFixed(1) : '0';
        return {
          name: datum.type,
          value: `${datum.value} (${percentage}%)`,
        };
      },
    },
  };

  return (
    <Card className="company-type-distribution-card">
      <div className="chart-title">Company Type Distribution</div>
      <Pie {...config} />
    </Card>
  );
};

export default CompanyTypeDistribution;
